import { render, staticRenderFns } from "./ComposerAttachment.vue?vue&type=template&id=531b0e4a&scoped=true"
import script from "./ComposerAttachment.vue?vue&type=script&lang=js"
export * from "./ComposerAttachment.vue?vue&type=script&lang=js"
import style0 from "./ComposerAttachment.vue?vue&type=style&index=0&id=531b0e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531b0e4a",
  null
  
)

export default component.exports